import { get, map } from 'lodash';
import { setDiagnoses } from './actions';
import DiagnosesService from './DiagnosesService';
import { currentPatientIdSelector } from '../patient';

//HELPERS
const toDiagnosesRequest = (
  { custom, id, treatingDoctorId, icd10Code, notes },
  patientId,
) => ({
  custom,
  id,
  treatingDoctorId,
  icd10codeid: get(icd10Code, 'id'),
  patientId,
  notes,
});

const toRequest = (diagnoses, patientId) => ({
  diagnoses: map(diagnoses, diagnosis =>
    toDiagnosesRequest(diagnosis, patientId),
  ),
  patientId,
});

//THUNKS
export const fetchDiagnosesAsync = () => (dispatch, getState) => {
  const state = getState();
  const patientId = currentPatientIdSelector(state);

  return dispatch(DiagnosesService.getByPatientId(patientId)).then(diagnoses =>
    dispatch(setDiagnoses(diagnoses)),
  );
};

export const saveDiagnosesAsync = diagnoses => (dispatch, getState) => {
  const state = getState();
  const patientId = currentPatientIdSelector(state);

  return dispatch(
    DiagnosesService.create(toRequest(diagnoses, patientId)),
  ).then(() => dispatch(setDiagnoses(diagnoses)));
};

export const searchDiagnosesAsync = (searchText, page) => dispatch => {
  if (!searchText) return Promise.resolve([]);
  return dispatch(DiagnosesService.search(searchText, page));
};



// WEBPACK FOOTER //
// ./src/lib/dataLayer/diagnoses/thunks.js